import { IQuestionAndAnswer } from "./types";
import { questionsAndAnswersTrns } from "../trns";

export const QUESTIONS_ANSWERS: IQuestionAndAnswer[] = [
  {
    id: 1,
    question: {
      i18nKey: questionsAndAnswersTrns.questionWhatBusinessClone,
    },
    answer: {
      i18nKey: questionsAndAnswersTrns.answerWhatBusinessClone,
    }
  },
  {
    id: 2,
    question: {
      i18nKey: questionsAndAnswersTrns.questionHowRegister,
    },
    answer: {
      i18nKey: questionsAndAnswersTrns.answerHowRegister,
    }
  },
  {
    id: 3,
    question: {
      i18nKey: questionsAndAnswersTrns.questionChooseBroker,
    },
    answer: {
      i18nKey: questionsAndAnswersTrns.answerChooseBroker,
    }
  },
  {
    id: 4,
    question: {
      i18nKey: questionsAndAnswersTrns.questionProcessBuying,
    },
    answer: {
      i18nKey: questionsAndAnswersTrns.answerProcessBuying,
    }
  },
  {
    id: 5,
    question: {
      i18nKey: questionsAndAnswersTrns.questionGuarantees,
    },
    answer: {
      i18nKey: questionsAndAnswersTrns.answerGuarantees,
    }
  },
  {
    id: 6,
    question: {
      i18nKey: questionsAndAnswersTrns.questionBusinessValuation,
    },
    answer: {
      i18nKey: questionsAndAnswersTrns.answerBusinessValuation,
    }
  },
  {
    id: 7,
    question: {
      i18nKey: questionsAndAnswersTrns.questionSupportAfterPurchase,
    },
    answer: {
      i18nKey: questionsAndAnswersTrns.answerSupportAfterPurchase,
    }
  },
  {
    id: 8,
    question: {
      i18nKey: questionsAndAnswersTrns.questionDisputes,
    },
    answer: {
      i18nKey: questionsAndAnswersTrns.answerDisputes,
    }
  },
  {
    id: 9,
    question: {
      i18nKey: questionsAndAnswersTrns.questionTransferAssets,
    },
    answer: {
      i18nKey: questionsAndAnswersTrns.answerTransferAssets,
    }
  },
  {
    id: 10,
    question: {
      i18nKey: questionsAndAnswersTrns.questionPreliminaryAudit,
    },
    answer: {
      i18nKey: questionsAndAnswersTrns.answerPreliminaryAudit,
    }
  },
  {
    id: 11,
    question: {
      i18nKey: questionsAndAnswersTrns.questionCosts,
    },
    answer: {
      i18nKey: questionsAndAnswersTrns.answerCosts,
    }
  },
  {
    id: 12,
    question: {
      i18nKey: questionsAndAnswersTrns.questionSellMultipleCountries,
    },
    answer: {
      i18nKey: questionsAndAnswersTrns.answerSellMultipleCountries,
    }
  },
  {
    id: 13,
    question: {
      i18nKey: questionsAndAnswersTrns.questionDataConfidentiality,
    },
    answer: {
      i18nKey: questionsAndAnswersTrns.answerDataConfidentiality,
    }
  },
  {
    id: 14,
    question: {
      i18nKey: questionsAndAnswersTrns.questionBrokerServices,
    },
    answer: {
      i18nKey: questionsAndAnswersTrns.answerBrokerServices,
    }
  },
  {
    id: 15,
    question: {
      i18nKey: questionsAndAnswersTrns.questionSuitableForRegion,
    },
    answer: {
      i18nKey: questionsAndAnswersTrns.answerSuitableForRegion,
    }
  },
  {
    id: 16,
    question: {
      i18nKey: questionsAndAnswersTrns.questionSuccessGuarantees,
    },
    answer: {
      i18nKey: questionsAndAnswersTrns.answerSuccessGuarantees,
    }
  },
  {
    id: 17,
    question: {
      i18nKey: questionsAndAnswersTrns.questionFinancialAssistance,
    },
    answer: {
      i18nKey: questionsAndAnswersTrns.answerFinancialAssistance,
    }
  },
  {
    id: 18,
    question: {
      i18nKey: questionsAndAnswersTrns.questionLoanConditions,
    },
    answer: {
      i18nKey: questionsAndAnswersTrns.answerLoanConditions,
    }
  },
  {
    id: 19,
    question: {
      i18nKey: questionsAndAnswersTrns.questionSubsidies,
    },
    answer: {
      i18nKey: questionsAndAnswersTrns.answerSubsidies,
    }
  },
  {
    id: 20,
    question: {
      i18nKey: questionsAndAnswersTrns.questionGrants,
    },
    answer: {
      i18nKey: questionsAndAnswersTrns.answerGrants,
    }
  },
];